export default function AdminCasos() {
  return (
    <div>
      <h1 className="text-3xl font-bold text-gradient mb-8">Gestión de Casos</h1>
      <p className="text-gray-300">Aquí podrás crear, editar y gestionar los casos de éxito.</p>
    </div>
  )
}
